import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-purple-900 text-white py-10 px-6">
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
        {/* Branding */}
        <div>
          <h1 className="text-2xl font-bold mb-2">EmpowerHer</h1>
          <p className="text-sm">
            Uplifting stories, real impact. Join us in making a difference.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-semibold mb-3">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:underline">Home</Link></li>
            <li><Link to="/stories" className="hover:underline">Stories</Link></li>
            <li><Link to="/contact" className="hover:underline">Contact Us</Link></li>
             <li><Link to="/privacypolicy" className="hover:underline">Privacy Policy</Link></li>
            
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h3 className="text-xl font-semibold mb-3">Follow Us</h3>
          <div className="flex space-x-4 text-lg">
            <a href="/" className="hover:text-gray-300"><FaFacebook /></a>
            <a href="/" className="hover:text-gray-300"><FaInstagram /></a>
            <a href="https://chat.whatsapp.com/LIENtaQeFv1E6u8qiI9hj6" className="hover:text-gray-300"><FaWhatsapp /></a>
           {/* <li><Link to="www.linkedin.com/in/empowerherforfuture"className="hover:text-gray-300"><FaLinkedin /></Link> </li>  */}
            <a href="https://linkedin.com/in/empowerherforfuture" className="hover:text-gray-300"><FaLinkedin /></a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center text-sm mt-10 text-gray-300">
        © {new Date().getFullYear()} EmpowerHer. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
